import { Component, inject, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { HoldsFacade } from 'src/app/state/user/holds/holds.facade';
import { SearchModel } from 'src/app/models/search-model';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-user-holds',
  templateUrl: './user-holds.component.html',
  styleUrls: ['./user-holds.component.scss'],
})
export class UserHoldsComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly configService = inject(ConfigService);

  readonly holds$ = this.holdsFacade.holds$;
  readonly isLoading$ = this.holdsFacade.isLoading$;

  section = 'holds';
  userService: UserService;

  constructor(
    userService: UserService,
    private holdsFacade: HoldsFacade,
  ) {
    this.userService = userService;
  }

  ngOnInit() {}

  exploreFullCatalog() {
    const model = new SearchModel(undefined, this.configService.get().resultsFilterOrder);
    model.explore = true;
    this.router.navigate(['/results'], {
      queryParams: model.toRequest(),
    });
  }
}
